import { Component, OnInit } from '@angular/core';
import { BasePageComponent } from '../../base-page.component';
import { ActionPlanService } from '../../shared/services/index';
import { ActivatedRoute, Router, Params } from '@angular/router';
import { Location } from '@angular/common';
import { ActionPlanItem, ActionPlanModel } from '../../shared/models/index';
import { ObservationsAndRecommandationsPluginService } from '../../plugins/observationsandrecommandations/observationsandrecommandations-plugin.service';
import * as _ from 'lodash';
import { ActionPlanItemsMenuComponent } from '../../menus/action-plan-items.menu';

@Component({
    templateUrl: './responsible-detail.component.html',
    standalone: false
})
export class ResponsibleDetailPageComponent extends BasePageComponent implements OnInit {
  public actionPlanId: string;
  public actionPlan: ActionPlanModel;
  public responsibleIndex: number;
  public responsibleName: string;
  public actionPlanItems: ActionPlanItem[];
  public loading = false;

  constructor(
    public actionPlanService: ActionPlanService,
    private activatedRoute: ActivatedRoute,
    private service: ObservationsAndRecommandationsPluginService,
    private router: Router,
    location: Location
  ) {
    super(location);
  }

  ngOnInit() {
    this.loading = true;
    this.activatedRoute.params.subscribe((params: Params) => {
      const id = params['actionPlanId'];
      if (id == null) {
        this.router.navigate([this.actionPlansRoute]);
      }

      const responsibleIndex = params['responsibleIndex'];
      if (responsibleIndex == null) {
        this.router.navigate([this.actionPlansRoute]);
      }

      this.actionPlanId = id;
      this.responsibleIndex = responsibleIndex;
      // this.responsibleName = this.service.getResponsibleName(this.responsibleIndex);
      this.actionPlanService.getActionPlan(this.actionPlanId).subscribe((data) => {
        this.actionPlan = data;
        const group = _.find(data.responsibleList, (o) => o.side === this.responsibleIndex);
        // this.actionPlanItems = data.responsibleList[this.responsibleIndex].actionPlanItems;
        this.actionPlanItems = group.actionPlanItems;
        this.loading = false;
      });
    });
  }

  public openItem(item: ActionPlanItem) {
    this.router.navigate([this.actionPlansRoute, this.actionPlanId, 'actionPlanItem', item.id]);
  }

  public openMenu(): void {
    this.modal.modalFooter = false;
    this.modal.modalHeader = false;
    this.modal.modalMessage = false;
    this.modal.open(ActionPlanItemsMenuComponent);
  }

  public selectMenu(item: any) {
    switch (item) {
      case 1:
        break;
      default:
    }
  }
}
